import { Link } from "react-router-dom";
import { useState } from "react";

const ProjectCon = ({ projects, setP, pFlag, showPopupFlag }) => {

    const [hoveredProject, setHoveredProject] = useState(null);

    const afterProjectClick = (project) => {
        setP(project);
        pFlag(true);
    }

    return (
        <div className="projects">
            {
                projects.map((project, index) => {
                    return (
                        <div
                            key={index}
                            className="project-con"
                            onMouseEnter={() => setHoveredProject(index)}
                            onMouseLeave={() => setHoveredProject(null)}
                            onClick={() => showPopupFlag ? afterProjectClick(project) : ""}
                        >
                            {project.image && (
                                <div className="project-img-con">
                                    <div
                                        className={`project-image ${hoveredProject === index && project.video ? 'fade-out' : ''}`}
                                        style={{ backgroundImage: `url(${project.image})` }}
                                    ></div>
                                    {project.video && (
                                        <video
                                            className={`project-video ${hoveredProject === index ? 'fade-in' : 'hidden'}`}
                                            src={project.video}
                                            autoPlay
                                            muted
                                            loop
                                            playsInline
                                        />
                                    )}
                                </div>
                            )}

                            <h3 className="project-name">{project.name}</h3>
                            <h4 className="project-desc">
                                {project.desc && project.desc.length > 100
                                    ? project.desc.slice(0, 100) + "..."
                                    : project.desc}
                            </h4>

                            {project.desc2 ? <h4 className="project-desc">{project.desc2}</h4> : ""}
                            <div className="project-links">
                                {project.links.link ?
                                    <Link to={project.links.link} target="_blank">
                                        <i className="fa-solid fa-link"></i>
                                    </Link>
                                    : ""}
                                {project.links.doc ?
                                    <Link to={project.links.doc} target="_blank">
                                        <i className="fa-solid fa-file"></i>
                                    </Link>
                                    : ""}
                                {project.links.github ?
                                    <Link to={project.links.github} target="_blank">
                                        <i className="fa-brands fa-github"></i>
                                    </Link>
                                    : ""}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default ProjectCon;